import { createGlobalStyle } from 'styled-components';

export const FreezeScreen = createGlobalStyle`
  body {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
  }
`;

if (!import.meta.env.PROD) {
  FreezeScreen.displayName = 'FreezeScreen';
}
